<template>
  <div v-if="isLoaded">
    <!-- Inline -->
    <div class="row q-mb-md">
      <!-- Filters hide/show button -->
      <div class="col-6">
      </div>
      <div class="col-6" style="justify-content: flex-end">
        <!-- Add question button -->
        <q-btn v-if="$store.state.meStore.me.rights.includes(`faq.question.add`) || $store.state.meStore.me.su"
          class="capitalize q-ml-md ctrl-button right"
          color="ctrl-turquoise"
          :label="getString('module.faq.action.add.question')"
          @click="$router.push('/faq/question/add')"
          icon-right="add"
        />
        <!-- Add category button -->
        <q-btn v-if="$store.state.meStore.me.rights.includes(`faq.category.add`) || $store.state.meStore.me.su"
          class="capitalize q-ml-md ctrl-button right"
          color="ctrl-turquoise"
          :label="getString('module.faq.action.add.category')"
          @click="$router.push('/faq/category/add')"
          icon-right="add"
        />
      </div>
    </div>
    <!-- <button @click="allowDrag = !allowDrag">Sort</button> -->
    <draggable :disabled="!$store.state.meStore.me.rights.includes(`faq.category.sort`)" v-model="categories" handle=".handle" v-bind="dragOptions" @start="drag = true" @end="sortCategories()">
      <transition-group type="transition" :name="!drag ? 'flip-list' : null">
        <div v-for="category in categories" :key="category.id">
          <div class="collapse">
            <q-collapsible @show="getQuestions(category.id)" group="categories" :label="`<strong>${category.name}</strong>${category.parent ? ` - (${category.parent.name})` : ''}`" :to="`/faq/category/${category.id}`">
              <!-- <q-btn :to="`/product/category/${category.id}`" label="To detail"/> -->
              <div :id="category.name" class="q-table q-table__auto">
                <vuetable
                  ref="vuetable"
                  pagination-path
                  :api-mode="false"
                  :data="questions[category.id]"
                  :css="css.table"
                  :fields="columns"
                  :row-class="selectable ? applyRowClass : null"
                  @vuetable:row-clicked="selectRows"
                  >
                  <!-- filterable -->
                  <div slot="filterable" slot-scope="props">
                    <q-toggle v-model="props.rowData.filterable"
                      @input="toggle(props.rowData, 'filterable', category.id)" color="secondary"
                    />
                  </div>
                  <!-- online -->
                  <div slot="online" slot-scope="props">
                    <q-toggle v-model="props.rowData.online"
                      @input="toggle(props.rowData, 'online', category.id)" color="secondary"
                    />
                  </div>
                </vuetable>
              </div>
            </q-collapsible>
            <div class="handle">
              <div class="minimized">
                <q-icon
                  color="grey-1"
                  name="mdi-dots-horizontal"
                  size="1.2rem"
                />
              </div>
            </div>
          </div>
        </div>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
import qs from 'qs';
import Vuetable from 'vuetable-2';
import draggable from 'vuedraggable';
import _debounce from 'lodash.debounce';

import getString from '@/helpers/GetStrings';
import selectRows from '@/mixins/tables/selectRows';

/**
 * This component makes a single request to the product questions endpoint and sorts the questions by category on the frontend. The
 * The sorted questions are given to a table matching the category ID. The table uses data (non-api) mode. The
 * Categories can be dragged in order to reassign sort id's.
 */
export default {
  mixins: [
    selectRows,
  ],

  data() {
    return {
      isLoaded: false,
      selectable: true,
      dragIndex: null,
      drag: false,
      dragging: false,
      questions: {},
      other: [],
      filtered: {},
      filters: {
        other: '',
      },
      css: {
        table: {
          tableClass: 'vuetable ui selectable celled stackable attached table vuetable-fixed-layout',
          loadingClass: '',
          ascendingIcon: 'mdi mdi-chevron-up icon',
          descendingIcon: 'mdi mdi-chevron-down icon',
          handleIcon: '',
        },
      },
      categories: [],
      rowSelection: [],
      currentRow: null,
      previousRow: null,
      columns: [
        {
          name: 'title',
          title: 'Title',
          titleClass: 'text-left sortable vcol-l',
          dataClass: 'text-left vcol-l text-ellipsis',
        },
        {
          name: '__slot:online',
          title: 'Online',
          titleClass: 'text-left sortable vcol-xs',
          dataClass: 'text-left vcol-xs text-ellipsis',
        },
      ],
    };
  },

  components: {
    draggable,
    Vuetable,
  },

  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      };
    },
  },

  methods: {
    getString,

    setDraggableRows() {
      setTimeout(() => {
        const isDraggable = document.getElementsByClassName('ctrl-row-select');
        [].forEach.call(isDraggable, (element) => {
          element.setAttribute('draggable', true);
        });
      }, 100);
    },

    initTableEvents() {
      this.$nextTick(() => {
        this.categories.forEach((category) => {
          document.getElementById(category.name).addEventListener('dragstart', this.handleDragStart, { passive: true });
          document.getElementById(category.name).addEventListener('dragenter', this.handleDragEnter, { passive: true });
          document.getElementById(category.name).addEventListener('dragend', this.handleDragEnd, { passive: true });
        });
      });
    },

    removeTableEvents() {
      document.removeEventListener('dragstart', this.handleDragStart);
      document.removeEventListener('dragEnd', this.handleDragEnd);
      document.removeEventListener('dragenter', this.handleDragEnter);
    },

    handleDragStart(evt) {
      const dragImg = document.createElement('img');
      evt.dataTransfer.setData('text/plain', 'anything');
      evt.dataTransfer.setDragImage(dragImg, 1, 1);
      this.dragging = true;
    },

    handleDragEnter(evt) {
      this.previousRow = this.currentRow;
      this.dragging && evt.target.click();
    },

    handleDragEnd() {
      this.previousRow = null;
      this.currentRow = null;
      this.rowSelection = [];
      this.dragging = false;
    },

    // Applies a css class to selected rows.
    applyRowClass(dataItem) {
      return this.rowSelection.indexOf(dataItem.id) > -1 ? 'ctrl-row-select' : '';
    },

    sortCategories() {
      const sorted = {};
      this.categories.forEach(category => (Object.assign(sorted, { [`category[${category.id}]`]: this.categories.indexOf(category) + 1 })));

      this.axios.put('faq/category/sort', qs.stringify(sorted));
      this.drag = false;
    },

    putQuestionsSort: _debounce(function (questions, id) {
      const sorted = {};
      questions.forEach(question => (Object.assign(sorted, { [`question[${question.id}]`]: questions.indexOf(question) + 1 })));
      this.axios.put(`faq/category/${id}/sort`, qs.stringify(sorted));
    }, 500),

    applySortation(row) {
      // update the sort id of each element in the row selection
      this.questions[row.category.id].forEach((feature) => {
        if (this.rowSelection.includes(feature.id)) {
          if (this.previousRow && this.previousRow.sort_id > this.currentRow.sort_id) {
            feature.sort_id = this.dragIndex - 0.1;
          } else if (this.previousRow && this.previousRow.sort_id < this.currentRow.sort_id) {
            feature.sort_id = this.dragIndex + 0.1;
          } else {
            feature.sort_id = this.dragIndex;
          }
        }
      });
      this.questions[row.category.id].sort((a, b) => a.sort_id - b.sort_id);

      for (let index = 0; index < this.questions[row.category.id].length; index += 1) {
        this.questions[row.category.id][index].sort_id = index + 1;
      }

      // Send the sortation put request for the feature category
      this.putQuestionsSort(this.questions[row.category.id], row.category.id);
    },

    // Selects rows on row click.
    selectRows(row, event) {
      this.currentRow = row;

      if (this.dragging) {
        // Do not sort while dragging through current selection
        if (this.rowSelection.includes(row.id)) {
          return;
        }

        this.dragIndex = row.sort_id;

        if (this.dragging && this.rowSelection.length) {
          this.applySortation(row);
        }

        // If metaKey is pressed & the row is not in the selection, add to selection
      } else if (!this.rowSelection.includes(row.id) && event.metaKey) {
        this.rowSelection.push(row.id);

      // If metaKey is pressed & the row is already in the selection, remove from selection.
      } else if (this.rowSelection.includes(row.id) && event.metaKey) {
        this.rowSelection.splice(this.rowSelection.indexOf(row.id), 1);

      // If the current row is the only row selected, go to the row detail when clicked again.
      } else if (this.rowSelection.length === 1 && this.rowSelection.includes(row.id)) {
        if (this.$store.state.meStore.me.rights.includes('faq.question.edit') || this.$store.state.meStore.me.su) {
          !this.dragging && this.$router.push(`/faq/category/${row.category.id}/question/${row.id}`);
        }

      // When using shift select, we need to select on row number due to sorted columns.
      } else if (event.shiftKey && this.rowSelection.length) {
        this.shiftSelect(row, this.questions[row.category.id].map(feature => feature.id));

      // Simple click sets the clicked row as the rowSelection.
      } else {
        this.rowSelection = [row.id];
      }
      this.setDraggableRows();
    },

    shiftSelect(row, data) {
      // rowIndexes is used to store the positions (row numbers) of the rows.
      // This is sorted so that intermediate rows can be added to rowSelection regardless of id.
      const rowIndexes = [];

      // The row numbers of the first & last rows in the selection.
      const firstRow = data.indexOf(this.rowSelection[0]);
      const lastRow = data.indexOf(this.rowSelection[this.rowSelection.length - 1]);

      // Push the position of the selected row into rowIndexes.
      rowIndexes.push(data.indexOf(row.id));

      // Check if clicked row is above the first rowSelection item.
      if (rowIndexes[0] > firstRow) {
        // If true, push the first rowSelection item.
        rowIndexes.push(firstRow);

        // If false push the last rowSelection item.
      } else {
        rowIndexes.push(lastRow);
      }

      // Sort the rowIndex array from smallest to largest.
      rowIndexes.sort((a, b) => a - b);

      // Empty row selection
      this.rowSelection = [];

      // Select all rows
      for (let i = rowIndexes[0]; i <= rowIndexes[rowIndexes.length - 1]; i += 1) {
        this.rowSelection.push(data[i]);
      }
    },

    // Method to fetch categories
    getCategories() {
      return new Promise((resolve, reject) => {
        this.axios.get('faq/category').then((res) => {
          this.categories = res.data.categories;
          //   this.categories.forEach((category) => {
          //     Object.assign(this.questions, { [category.id]: [] });
          //   });
          resolve();
        }).catch((err) => {
          reject(err);
        }).finally(() => {
          this.isLoaded = true;
        });
      });
    },

    toggle(rowData, property, categoryId) {
      const isActive = rowData[property] ? 1 : 0;
      this.axios.put(`/faq/category/${categoryId}/question/${rowData.id}`, qs.stringify({ [property]: isActive }))
        .catch((err) => {
          console.warn(err);
        });
    },

    highlight(field, filter) {
      // Build regex to match query string.
      const regex = new RegExp(filter, 'gi');

      // Match and replace query string with highlighted text.
      return field
        .replace(regex, matchedTxt => (`<span class='highlight'>${matchedTxt}</span>`));
    },

    // Method to fetch the product questions
    getQuestions(categoryId) {
      this.axios.get(`faq/category/${categoryId}/question`).then((res) => {
        this.sortQuestions(res.data.questions, categoryId);
      }).catch((err) => {
        console.warn(err);
      }).finally(() => {
        this.isLoaded = true;
        this.initTableEvents();
      });
    },

    // Method to sort the questions by respective category ID's
    sortQuestions(questions, categoryId) {
      this.$set(this.questions, categoryId, questions);
    },
  },

  mounted() {
    this.getCategories();
  },

  destroyed() {
    this.removeTableEvents();
  },
};
</script>

<style lang="stylus" scoped>
@import '~variables';
@import '../styles/components/tables.general.styl';
.collapse
  // display flex
  justify-content space-between
  width 100%
  background-color: #fff;
  border-right 2px #ACACAC dashed
  border-top 2px #ACACAC dashed
  border-left 2px #ACACAC dashed
  border-radius: 4px;
  margin-bottom 20px
  // padding: 10px;
  // background-color $secondary
  // color white
.handle
  cursor move
  display inline-block
  vertical-align middle
  width 100%
  height 1.4rem
  border-right 2px #929AAD dashed
  border-bottom 2px #929AAD dashed
  border-left 2px #929AAD dashed
  background-color #ACACAC
.minimized
  color #ccc
  display flex
  justify-content center

.disable-drag
  display inline-block
  vertical-align middle
  width 100%
  height 1.2rem
  border-right 2px #929AAD dashed
  border-bottom 2px #929AAD dashed
  border-left 2px #929AAD dashed
  background-color #CDCDCD
</style>
